import { buildHeaders } from "./apiConfig";
import { DELETE_FILES_API_URL } from "../constants";

export async function deleteJobFiles(jobId) {
  if (!jobId) {
    throw new Error("[deleteFilesService] jobId is required.");
  }

  const url = DELETE_FILES_API_URL.replace(/\/$/, "");
  const payload = JSON.stringify({ job_id: jobId });

  // eslint-disable-next-line no-console
  console.log(`[deleteFilesService] POST ${url}`, { job_id: jobId });

  let response;
  try {
    response = await fetch(url, {
      method: "POST",
      headers: buildHeaders(),
      body: payload,
    });
  } catch (networkErr) {
    throw new Error("Network error while deleting job files. Please check your connection.");
  }

  let json = {};
  try {
    json = await response.json();
  } catch {
    /* non-JSON body — fall through */
  }

  if (!response.ok) {
    const detail = json.error || json.message || `HTTP ${response.status}`;
    // eslint-disable-next-line no-console
    console.error(`[deleteFilesService] ❌ ${response.status} — ${detail}`);
    throw new Error(detail);
  }

  // eslint-disable-next-line no-console
  console.log("[deleteFilesService] ✅ Job files deleted successfully.", json);
  return json;
}
